import { createReducer } from "typesafe-actions";

import {
  disposeUserLocations,
  fetchEvents,
  setDisabledUserIds,
  setSelectedDate,
  setSelectedDatePeriod,
  setSelectedUserIds,
  UserLocationActions,
} from "../actions";

import { setPlayback } from "./actions";
import { IDLE_PLAYBACK_STATE } from "./consts";
import PlaybackState from "./types/PlaybackState";

// Playback slice. Any data, selection, or date change parks playback back on Idle.
const playback = createReducer<PlaybackState, UserLocationActions>(IDLE_PLAYBACK_STATE)
  .handleAction(setPlayback, (_state, { payload }) => payload)
  .handleAction(
    [
      disposeUserLocations,
      fetchEvents.request,
      setDisabledUserIds,
      setSelectedDate,
      setSelectedDatePeriod,
      setSelectedUserIds,
    ],
    () => IDLE_PLAYBACK_STATE
  );

export default playback;
